"use client";

import React, { useEffect, useState, useRef } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  value: 50,
  suffix: "+",
  label: "Enterprises Transformed"
}, {
  value: 30,
  suffix: "%",
  label: "Cost Reduction"
}, {
  value: 10,
  suffix: "+",
  label: "Years Expertise"
}, {
  value: 5,
  suffix: "+",
  label: "Countries Served"
}];
function CounterItem({
  item,
  index
}: {
  item: (typeof stats)[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const [count, setCount] = useState(0);
  const hasAnimated = useRef(false);
  useEffect(() => {
    if (isVisible && !hasAnimated.current) {
      hasAnimated.current = true;
      let start = 0;
      const end = item.value;
      const duration = 2000;
      const increment = end / (duration / 16);
      const timer = setInterval(() => {
        start += increment;
        if (start >= end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(Math.floor(start));
        }
      }, 16);
      return () => clearInterval(timer);
    }
  }, [isVisible, item.value]);
  return <div ref={ref} data-index={index} className={`flex flex-col items-center justify-center p-8 text-center md:border-r border-white/10 last:border-r-0 relative group`}>
      <div className="mb-4 relative">
        <span className="text-6xl md:text-7xl font-bold text-primary tracking-tighter tabular-nums drop-shadow-[0_0_15px_rgba(var(--primary),0.3)]">
          {count}
          {item.suffix}
        </span>
      </div>
      <p className="text-lg text-muted-foreground font-medium uppercase tracking-widest">
        {item.label}
      </p>
    </div>;
}
export default function RegionalImpact() {
  return <section id="regional-impact" className="dark bg-background text-foreground relative py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558991/img/east_africa_dotted_map.png)] bg-cover bg-center opacity-15 mix-blend-screen" />
        <div className="absolute inset-0 bg-gradient-to-b from-background via-transparent to-background" />
        <div className="absolute inset-0 bg-gradient-to-r from-background/50 via-transparent to-background/50" />
      </div>

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-7xl h-full pointer-events-none z-0">
        <div className="absolute top-[48%] left-[52%] flex items-center justify-center">
          <span className="absolute inline-flex h-6 w-6 animate-ping rounded-full bg-primary opacity-75 duration-1000"></span>
          <span className="relative inline-flex h-3 w-3 rounded-full bg-primary shadow-[0_0_20px_hsl(190_95%_50%)]"></span>
          <div className="absolute left-6 top-1/2 -translate-y-1/2 ml-2 px-2 py-1 bg-background/80 backdrop-blur-md border border-white/10 rounded text-xs text-primary font-mono uppercase tracking-wider opacity-0 animate-[fadeIn_1s_ease-out_1s_forwards]">
            Nairobi HQ
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-0 border-y border-white/10 bg-background/20 backdrop-blur-sm">
          {stats.map((item, i) => <CounterItem key={i} item={item} index={i} />)}
        </div>
      </div>
    </section>;
}